<template>
  <div class="rg05-box">
    <div class="rg05-box__header">
      <span class="name">{{ name }}</span>
      <span v-show="linkVisible" class="link">
        <span class="text" @click="toMonitor">详情</span>
        <span class="iconfont icon-dakai" @click="openNewWindow"></span>
      </span>
    </div>
    <div class="rg05-box__content">
      <AlarmIcon :state="state" />
      <div class="table-wrap">
        <div class="table-row">
          <span class="label">设备号</span>
          <span class="value">{{ sn }}</span>
        </div>
        <div class="table-row">
          <span class="label">电量</span>
          <span class="value">{{ powerPercent }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { windowOpen } from '@/utils/utils';
import AlarmIcon from './alarm-icon.vue';

export default {
  props: {
    sn: String,
    name: String,
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: { AlarmIcon },
  computed: {
    deviceType() {
      return this.data && this.data.deviceType;
    },
    rg05() {
      const mod = this.data && this.data.mods ? this.data.mods.nuclearMod : {};
      return mod.rg05;
    },
    powerPercent() {
      if (!this.rg05) return 0;
      return this.rg05.powerPercent;
    },
    state() {
      if (!this.rg05) return '-1';
      return this.rg05.alarmState;
    },
    linkVisible() {
      return this.state !== '-1';
    }
    // realValue() {
    //   if (!this.ciaeRms) return 0;
    //   return this.ciaeRms.realValue;
    // },
    // backgroundValue() {
    //   if (!this.ciaeRms) return 0;
    //   return this.ciaeRms.bgroundValue;
    // }
  },
  methods: {
    toMonitor() {
      if (!this.sn || !this.deviceType) return;
      this.$router.push({
        name: 'Realdata',
        params: {
          sn: this.sn,
          deviceType: this.deviceType
        }
      });
    },
    openNewWindow() {
      if (!this.sn || !this.deviceType) return;
      windowOpen(
        {
          name: 'Realdata',
          params: {
            sn: this.sn,
            deviceType: this.deviceType
          }
        },
        this.sn
      );
    }
  }
};
</script>

<style lang="scss">
.rg05-box {
  height: 100%;
  background-color: var(--device-card-bg);
  position: relative;
  overflow: hidden;
  &__header {
    display: flex;
    justify-content: space-between;
    color: $primary-text-color;
    font-size: 16px;
    background-color: var(--device-card-header-bg);
    padding: 8px 10px;
    .name {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .link {
      min-width: 58px;
      // text-decoration: underline;
      cursor: pointer;
    }
  }

  &__content {
    padding: 15px;
    display: flex;
    align-items: flex-end;
  }

  .table-wrap {
    margin-left: 15px;
    border-left: 1px solid var(--device-border-color);
    border-top: 1px solid var(--device-border-color);
    .table-row {
      display: flex;
      .label {
        flex: 1;
        min-width: 45px;
        max-width: 45px;
      }
      .value {
        flex: 1;
        min-width: 80px;
      }
      span {
        padding: 10px 5px;
        border-right: 1px solid var(--device-border-color);
        border-bottom: 1px solid var(--device-border-color);
      }
    }
  }
}
</style>
